// PATH: src/api/profile.ts — fiche d'identité de l'établissement.
// Mentions légales : réservé à la direction côté backend (403 attendu sinon).
import { useMemo } from "react";
import { useApiClient } from "./apiClients";

const BASE = "/api/v1/school";

export interface SchoolProfile {
  organization_id: number;
  legal_name?: string;
  /** Identifiant Commun de l'Entreprise — 15 chiffres. */
  ice?: string;
  /** Identifiant Fiscal. */
  tax_id?: string;
  rc_number?: string;
  /** Tribunal émetteur du registre de commerce. */
  rc_city?: string;
  patente?: string;
  address?: string;
  city?: string;
  postal_code?: string;
  phone?: string;
  email?: string;
  website?: string;
  logo_url?: string;
  /** Nom d'usage, joint depuis tc_identity. Lecture seule. */
  school_name?: string;
}

export const useProfileApi = () => {
  const http = useApiClient("tilmischool");

  return useMemo(
    () => ({
      get: () => http.get<SchoolProfile>(`${BASE}/profile`).then((r) => r.data),
      save: (p: Partial<SchoolProfile>) =>
        http.put<SchoolProfile>(`${BASE}/profile`, p).then((r) => r.data),
    }),
    [http]
  );
};
